import { render, staticRenderFns } from "./MergerAcquisitionForm.vue?vue&type=template&id=0cfd0dfb&"
import script from "./MergerAcquisitionForm.vue?vue&type=script&lang=ts&"
export * from "./MergerAcquisitionForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cfd0dfb')) {
      api.createRecord('0cfd0dfb', component.options)
    } else {
      api.reload('0cfd0dfb', component.options)
    }
    module.hot.accept("./MergerAcquisitionForm.vue?vue&type=template&id=0cfd0dfb&", function () {
      api.rerender('0cfd0dfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/mergerAcquisitions/MergerAcquisitionForm.vue"
export default component.exports